// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"304":"dd585a4e","559":"33eb5120","801":"d3fb3051","806":"6eb2b08e","866":"96cf5eab"}[chunkId] + ".css";
};